import React, { useContext } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import FiltersChipsContainer from '@totem/components/ui_components/filters/FilterChipsContainer';
import FilterChips from '@totem/components/ui_components/reportSettings/filterChips';
import InputContext from '@totem/components/ui_components/reportSettings/InputContext';

const styles = {
  searchContainer: {
    marginBottom: '2rem',
  },
  search: {
    width: '240px',
  },
};

const DeviceSyncMergesFilters = () => {
  const { getFilterValue, handleFilter } = useContext(InputContext);

  return (
    <>
      <div style={styles.searchContainer}>
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search device..."
          style={styles.search}
          value={getFilterValue('device')}
          onChange={(evt) => handleFilter('device', evt.target.value)}
          allowClear
        />
      </div>
      <FiltersChipsContainer>
        <FilterChips />
      </FiltersChipsContainer>
    </>
  );
};

export default DeviceSyncMergesFilters;
